<script lang="ts" setup>
// import IncrementIcon from '@/assets/IncrementIcon.svg?inline';
// import DecrementIcon from '@/assets/DecrementIcon.svg?inline';
import { IconButton } from '@laam/ui/base';
import { ProductTags } from './utils/Enums';
import { PhPlus, PhMinus } from '@phosphor-icons/vue';
import type { Product, ProductVariant } from '~/types/Product';
// import BulkPurchase from './BulkPurchase.vue';
// import { isHVCAdoptionEnabled } from '@/utils/experimentFlags';

interface QuantityComponentProps {
	productData: Product;

	selectedVariantData: ProductVariant | null;

	stockStatus: string;
}

const props = defineProps<QuantityComponentProps>();

const selectedQuantity = ref(1);
const emit = defineEmits<{
	(e: 'selectedQuantity', quantity: number): void;
}>();
function increment() {
	selectedQuantity.value++;
	emit('selectedQuantity', selectedQuantity.value);
}
function decrement() {
	if (selectedQuantity.value > 1) {
		selectedQuantity.value--;
		emit('selectedQuantity', selectedQuantity.value);
	}
}

const prod_enum = ProductTags;
// let showBulkPurchase = false;
// let bulkPopupOpened = false;

const maxBuyableQuantity = ref(props.productData.meta.cart_item_limit);

const remainingQuantity = computed<number>(() => {
	if (props.selectedVariantData) {
		return props.selectedVariantData.inventory_quantity;
	} else {
		return props.productData.total_inventory_quantity;
	}
});
</script>

<template>
	<div class="pdp__quantity-selector gap-3xl lg:gap-md flex flex-col">
		<span class="text-md font-semibold text-gray-800">Quantity</span>

		<div class="gap-3xl flex items-center">
			<div class="w-fit gap-md flex items-center">
				<IconButton
					size="sm"
					variant="secondary"
					class="pdp__quantity-selector-decrement-button"
					:disabled="
						props.stockStatus === 'out-of-stock' ||
						selectedQuantity === 1 ||
						remainingQuantity === 0
					"
					@click="decrement()"
				>
					<PhMinus class="h-3xl w-3xl" />
				</IconButton>

				<div class="place-content-center size-7xl grid select-none">
					<span class="selected-quantity text-sm font-semibold">
						{{ props.stockStatus === 'out-of-stock' ? 0 : selectedQuantity }}
					</span>
				</div>

				<IconButton
					id="increment-button"
					size="sm"
					variant="secondary"
					class="pdp__quantity-selector-increment-button"
					:disabled="
						props.stockStatus === 'out-of-stock' ||
						selectedQuantity === maxBuyableQuantity ||
						selectedQuantity === remainingQuantity
					"
					@click="increment()"
				>
					<PhPlus class="h-3xl w-3xl" />
				</IconButton>
			</div>

			<div
				v-if="props.productData.tags.includes(prod_enum.HVC_SET) === false"
				class="select-none"
			>
				<span
					v-if="props.stockStatus === 'in_stock'"
					class="info-max-pieces text-sm text-gray-600"
				>
					{{ maxBuyableQuantity }} pieces at most per customer
				</span>
				<span
					v-else-if="props.stockStatus === 'limited_stock'"
					class="info-limited-pieces text-sm text-gray-600"
				>
					Only
					{{
						props.selectedVariantData
							? props.selectedVariantData.quantityAvailable
							: props.productData.total_inventory_quantity
					}}
					in stock
				</span>
				<span
					v-else-if="props.stockStatus === 'out-of-stock'"
					class="info-out-of-stock text-sm text-gray-600"
				>
					Out of stock
				</span>
				<span v-else class="text-sm text-gray-600">
					Maximum {{ maxBuyableQuantity }} pieces per order
				</span>
			</div>
			<span v-else class="text-sm text-gray-600">
				Max order: {{ maxBuyableQuantity }} sets
			</span>
		</div>
	</div>
</template>
